import React from "react";
import useLanguageChange from "../../hooks/useLanguageChange";
import { PublicVariables } from "../../constants/PublicVariables";
import { useFlags } from "launchdarkly-react-client-sdk";
import endCallService from "../../services/endCallService";

const EndCallButton = () => {
    const localisedValues = useLanguageChange();
    const ldFlags = useFlags();

    const handleEndCall = () => {
        if (PublicVariables.isMobile) {
            endCallService.confirmEndCall(ldFlags?.popupOnDisconnect);
        } else {
            endCallService.manageEndcall();
        }
    };

    return (
        <div className='action-button endcall-action-button'>
            <div className='action-button-in'>
                <button className='call-action-btn' data-testid='endCallBtn' onClick={() => handleEndCall()}>
                    <span className='action-button-icon'>
                        <span className='for-icon icon-end-call'></span>
                    </span>
                    <span className='for-text'>{localisedValues?.disconnect}</span>
                </button>
            </div>
        </div>
    );
};

export default EndCallButton;
